/**
 * Utils to work with elements on the page both at load time but also after the "infiniteScroll" event
 * is triggered.
 *
 * Methods:
 * - domUtils.on(cacheKey, selector, event, callback)
 *   Binds the `event` for all elements matching `selector`.
 *   Listens for `infiniteScroll` event and adds the event listener when new content arrives
 *   `cacheKey` should be unique for marking the element as already inited
 *
 * - domUtils.forEach(cacheKey, selector, callback, forceTrue)
 *   Invokes `callback` for every element matching `selector`.
 *   Listens for `infiniteScroll` event and invokes the callback for new elements when new content arrives.
 *   `cacheKey` should be unique for marking the element as already inited
 *
 *   By default, all elements are marked as already inited on the first run.
 *   Passing `forceTrue = true` won't mark the element as inited unless the callback returns true.
 *   This is useful for initializing sliders: the slider is *not* initialized if it's hidden (default state),
 *   only when the slider is shown should it be inited. Thus, the callback for the slider returns false on the first run,
 *   true when the slider is shown - after this the same element will be skipped from the callback
 */
define(["wfcb/amd/docIsReady"], function (docIsReady) {
    var elIsInited = function (el, key) {
        el.cronicaInit = el.cronicaInit || {};
        if (el.cronicaInit[key]) {
            return true;
        }

        return false;
    };

    var iterate = function (cacheKey, selector, callback, forceRet) {
        docIsReady(function () {
            document.querySelectorAll(selector).forEach(function (el) {
                if (elIsInited(el, cacheKey)) {
                    return;
                }

                var ret = callback(el);

                if (!forceRet || ret === true) {
                    el.cronicaInit[cacheKey] = true;
                }
            });
        });
    };

    return {
        forEach: function (cacheKey, selector, callback, forceRet) {
            var init = iterate.bind(
                null,
                cacheKey,
                selector,
                callback,
                forceRet
            );

            document.addEventListener("infiniteScroll", init);
            init();
        },
        on: function (cacheKey, selector, event, callback) {
            var init = iterate.bind(null, cacheKey, selector, function (el) {
                el.addEventListener(event, callback);

                return true;
            });

            document.addEventListener("infiniteScroll", init);
            init();
        },
        getAbsoluteHeight: function (el) {
            // Get the DOM Node if you pass in a string
            el = typeof el === "string" ? document.querySelector(el) : el;

            var getElMargin = function (el) {
                var styles = window.getComputedStyle(el);

                return (
                    parseFloat(styles["marginTop"]) +
                    parseFloat(styles["marginBottom"])
                );
            };

            var margin = getElMargin(el);

            var childMargin = 0;
            (function getChildrenMargin(el) {
                if (
                    el.nodeName === "INS" ||
                    el.nodeName === "IFRAME" ||
                    el.nodeName === "TEXT"
                ) {
                    return;
                }

                childMargin += getElMargin(el);
                if (el.hasChildNodes()) {
                    getChildrenMargin(el.firstElementChild);
                }
            })(el);

            margin = margin + childMargin;

            return Math.ceil(el.offsetHeight + margin);
        },
        getOffset: function (_el) {
            var target = _el,
                target_width = target.offsetWidth,
                target_height = target.offsetHeight,
                target_left = target.offsetLeft,
                target_top = target.offsetTop,
                gleft = 0,
                gtop = 0,
                rect = {};

            var moonwalk = function (_parent) {
                if (!!_parent) {
                    gleft += _parent.offsetLeft;
                    gtop += _parent.offsetTop;
                    moonwalk(_parent.offsetParent);
                } else {
                    return (rect = {
                        top: target.offsetTop + gtop,
                        left: target.offsetLeft + gleft,
                        bottom: target.offsetTop + gtop + target_height,
                        right: target.offsetLeft + gleft + target_width,
                    });
                }
            };
            moonwalk(target.offsetParent);

            return rect;
        },
    };
});
